import http from './http'
import Loader from './loader'
import MicroModal from 'micromodal'
export default class Forms {
    constructor (el) {
        this.el = el

        this.loader = new Loader(this.el.querySelector('[type=submit]'))

        this.el.addEventListener('submit', (e) => {
            e.preventDefault()
            this.submitHandler()
        })

    }

    async submitHandler () {
        if (this.loader.isLoading()) {
            return
        }
        try {
            this.loader.start()
            let formData = new FormData(this.el)
            Object.keys(this.el.dataset).forEach((key) => {
                formData.append(key, this.el.dataset[key])
            })
            const response = await http.post(this.action, formData)
         
            if (response.status === 200) {
                if (response.data.data) {
                    const message = document.createElement('h4')
                    message.classList.add('form__success')
                    message.innerHTML = response.data.data
                    this.el.after(message)
                    this.el.remove()
                } else {
                    this.loader.stop(this.el.dataset.successMessage)
                    this.el.reset()
                    const modal = this.el.closest('.modal')
                    if (modal) {
                        MicroModal.close(modal.id)
                    }
                }            
            }
        } catch (error) {
            this.loader.error(error.response.data.data)
        }
    }
}